import styled from "@emotion/styled";
import { Flex } from "@otrium/core";

const StyledDropDownHeader = styled(Flex)`
  padding: ${({ theme }) => theme.space.space16};
  background: ${({ theme }) => theme.colors?.tone.sand};
  border-radius: ${({ theme }) => theme.effects.rounding._8};
  gap: ${({ theme }) => theme.space.space8};
  display: flex;
  align-items: center;

  svg {
    flex-shrink: 0;
  }
`;

const SizeGuideLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: ${({ theme }) => theme.colors.tone.black};
  text-decoration: underline;
`;

export { StyledDropDownHeader, SizeGuideLabel };
